import { render, staticRenderFns } from "./configurator.vue?vue&type=template&id=6c79e7e2&"
import script from "./configurator.vue?vue&type=script&lang=js&"
export * from "./configurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports